"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = require("react");
var _EnvContext = require("../../Env/EnvContext");
var useFeature = function useFeature(name, enabled) {
  if (enabled === void 0) {
    enabled = false;
  }
  var _useContext = (0, _react.useContext)(_EnvContext.EnvContext),
    featureFlags = _useContext.featureFlags;
  var featureEnabled = (0, _react.useMemo)(function () {
    return !!(featureFlags != null && featureFlags.includes(name));
  }, [name, enabled]);
  return featureEnabled;
};
var _default = exports["default"] = useFeature;